import * as React from "react";
import { translations } from "../i18n/en";
export const LanguageContext = React.createContext(undefined);
export const LanguageProvider = ({ children }) => (
  <LanguageContext.Provider
    value={{
      t: translations,
    }}
  >
    {children}
  </LanguageContext.Provider>
);
export const useLanguage = () => {
  const e = React.useContext(LanguageContext);
  if (e === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return e;
};
